import { ActiveRecorder } from '@/components/home/active-recorder';
import { getReportRouteSegment } from '@/lib/reports/status';
import { Navigate, useOutletContext } from 'react-router-dom';
import type { ReportContextType } from './layout';

export const ReportRecord = () => {
  const { report } = useOutletContext<ReportContextType>();
  const routeSegment = getReportRouteSegment(report.status);

  if (routeSegment !== 'record') {
    return <Navigate to={`/reports/${report._id}/${routeSegment}`} replace />;
  }

  return <ActiveRecorder report={report} />;
};
